import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat,findArrayObject, amountFormatOnly,isEmpty, getDateInStringDDMMMYYYY,numberWithCommas,checkNumberOnly,replaceCommas,sortByDisplay, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import { DialogTitle, TripActionDialogContent, DialogActions } from '../../components/Dialog/Dialog';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Switches,
  Autocomplete
} from 'mui-rff';
import {
  Typography,
  Paper,
  Link,
  Grid,
  Button,
  Card,
  Dialog,
  CardActions,
  CardContent,
  CssBaseline,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormControl,
  CardHeader,
  TextField as TextInput,
  Checkbox,
  Box,
  Tabs,
  Tab
} from '@material-ui/core';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
  getTripDetailsOnly,
  updateTripStatus,
  editVendorExpense,
  addVendorExpense
} from "../../../store/actions/tripActionCreator";
import {
  updateCreateVehicleOpen,
} from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces,isFunction } from "../../../utils/utils"
import inputStyles from '../../components/css/inputs'
import {
  TRIP_STATUS,
  TRIP_DISPLAY_STATUS,
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  PAYMENT_CHIPS,
  TRIP_ACTIONS_FORM_LABELS
} from "../../../store/constants";
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import addStyles from '../../components/css/addEditTrip';
import AddSupplier from '../../pages/Suppliers/AddSupplier';
import AddDriver from '../../components/AddDialogComponent/AddDialogComponent';
import { trackDwebEvent } from '../../analytics';
import clsx from 'clsx';
const filter = createFilterOptions({
  limit: 20,
  matchFrom: 'any'
});
const useStyles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  dialogContent: {
    padding: '16px 24px'
  },
  switchLabel: {
    marginLeft: 0
  },
  error: {
    color: 'red',
    marginBottom: 8
  }
}));
const AddEditTruckHireCost = (props) => {
  const formClasses = useStyles();
  const inputClasses = inputStyles();
  const classes = addStyles();
  let submit
  const {
    user,
    onConfirm,
    open,
    onClose,
    onSave,
    action,
    location,
    vehicle,
    defaultNumber,
    editData,
    dispatchAddVendorExpense,
    dispatchEditVendorExpense,
    selectedTrip,
    updateJourney,
    ...other
  } = props;
  let fleetOwnerId = user.userInfo.entityId;
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripDetails = user.singleTripData ? user.singleTripData : {};
  let tripId = selectedTrip && selectedTrip.id?selectedTrip.id:path[path.length-1];
  let vendorId = tripDetails && tripDetails.vendor && tripDetails.vendor.vendorId ?tripDetails.vendor.vendorId:0;
  const [dialogopen, setDialogOpen] = React.useState(open);
  const [truckHireCost, setTruckHireCost] = useState(tripId && editData && editData.amount ? numberWithCommas(parseInt(editData.amount)) : '');
  const [vendorBillingType, setVendorBillingType] = useState(tripId && tripDetails && tripDetails.vendor && tripDetails.vendor.invoicingType ? tripDetails.vendor.invoicingType : 'Fixed');
  const [vendorTotalUnits, setVendorTotalUnits] = useState(tripId && tripDetails && tripDetails.vendor && tripDetails.vendor.invoicingCalc && tripDetails.vendor.invoicingCalc.totalUnits ? tripDetails.vendor.invoicingCalc.totalUnits : '');
  const [vendorUnitPrice, setVendorUnitPrice] = useState(tripId && tripDetails && tripDetails.vendor && tripDetails.vendor.invoicingCalc && tripDetails.vendor.invoicingCalc.unitPrice ? numberWithCommas(tripDetails.vendor.invoicingCalc.unitPrice) : '');
  const validate = values => {
    const errors = {};
    if (!values.truckHireCost && values.vendorBillingType == 'Fixed' ) {
      errors.truckHireCost = 'Truck Hire Cost Required';
    }
    if (values.truckHireCost && values.vendorBillingType == 'Fixed'  && !checkNumberOnly(replaceCommas(values.truckHireCost))) {
      errors.truckHireCost = 'Invalid Truck Hire Cost';
    }
    if (values.truckHireCost && values.vendorBillingType == 'Fixed' && checkNumberOnly(replaceCommas(values.truckHireCost)) && Number(replaceCommas(values.truckHireCost))<=0) {
      errors.truckHireCost = 'Truck Hire Cost cannot be zero or negative';
    }
    if (!values.vendorBillingType) {
      errors.vendorBillingType = 'Required';
    }
    if (!values.vendorUnitPrice && values.vendorBillingType != 'Fixed') {
      errors.vendorUnitPrice = 'Required';
    }
    if (values.vendorUnitPrice && values.vendorBillingType != 'Fixed' && !checkNumberOnly(replaceCommas(values.vendorUnitPrice))) {
      errors.vendorUnitPrice = 'Invalid Rate';
    }
    if (values.vendorUnitPrice && values.vendorBillingType != 'Fixed' && checkNumberOnly(replaceCommas(values.vendorUnitPrice))&& Number(replaceCommas(values.vendorUnitPrice))<=0) {
      errors.vendorUnitPrice = 'Rate cannot be zero or negative';
    }
    if (!values.vendorTotalUnits && values.vendorBillingType != 'Fixed') {
      errors.vendorTotalUnits = 'Required';
    }
    if (values.vendorTotalUnits && values.vendorBillingType != 'Fixed' && !checkNumberOnly(replaceCommas(values.vendorTotalUnits))) {
      errors.vendorTotalUnits = 'Invalid Units';
    }
    if (values.vendorTotalUnits && values.vendorBillingType != 'Fixed' && checkNumberOnly(replaceCommas(values.vendorTotalUnits)) && Number(replaceCommas(values.vendorTotalUnits))<=0) {
      errors.vendorTotalUnits = 'Units cannot be zero or negative';
    }
    return errors;
  };
  const handleConfirm = (e) => {
    fetchTripDetails()
    onSave(false);
  }
  const handleClose = (status) => {
    fetchTripDetails()
    onClose(false);
  };
  const fetchTripDetails = ()=>{
    if (isFunction(updateJourney) && tripDetails.id) {
      updateJourney(tripDetails.id)
    }
  } 
  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    //window.alert(JSON.stringify(values, 0, 2));
    if (editData && editData.id) {
      let updateData = {}
      updateData = {
        ...editData,
        fleetOwnerId: fleetOwnerId,
        expenseDate: Number(editData.expenseDate),
        tripId: tripId,
        vendorId: vendorId,
        amount: Number(replaceCommas(values.truckHireCost))
      }
      updateData['vendorBillingType'] = values.vendorBillingType;
      if (values.vendorBillingType != 'Fixed') {
        updateData['vendorBillingDetails'] = { unitPrice: Number(replaceCommas(values.vendorUnitPrice)), totalUnits: Number(values.vendorTotalUnits) }
        updateData['amount'] = Number(values.vendorUnitPrice ? replaceCommas(values.vendorUnitPrice) : 0) * Number(values.vendorTotalUnits ? values.vendorTotalUnits : 0);
      }
      dispatchEditVendorExpense(updateData.id, updateData, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces("Truck Hire Cost Updated Successfully!");
          handleConfirm()
        } else {
        }
      },
        () => {
        })
    } else {
        let data = {
            fleetOwnerId: fleetOwnerId,
            expenseType:'Vehicle_Hire_Cost',
            expenseDate: Math.round(new Date().getTime()/1000),
            tripId: tripId,
            vendorId: vendorId,
            amount: Number(replaceCommas(values.truckHireCost))
        }
        data['vendorBillingType'] = values.vendorBillingType;
        if (values.vendorBillingType != 'Fixed') {
            data['vendorBillingDetails'] = { unitPrice: Number(replaceCommas(values.vendorUnitPrice)), totalUnits: Number(values.vendorTotalUnits) }
            data['amount'] = Number(values.vendorUnitPrice ? replaceCommas(values.vendorUnitPrice) : 0) * Number(values.vendorTotalUnits ? values.vendorTotalUnits : 0);
        }
        dispatchAddVendorExpense(data,(response)=>{
            if(response && response.status && response.status && response.status.code && response.status.code=== 200){
              sendSucces("Truck Hire Cost Added Successfully!");
                handleConfirm();
            }else{

            }
        },
        ()=>{
          
        })
    }
  };
  useEffect(() => {
  }, []);
  const getFormFields = (values) => {
    let {vendorBillingType } = values;
    let vendorUnitsPriceLabel = "";
    let vendorTotalUnitsLabel = "";
    let truckHireCostCard = "Truck Hire Cost";
    if (vendorBillingType === 'Per Tonne') {
        vendorUnitsPriceLabel = 'Rate Per Tonne';
        vendorTotalUnitsLabel = 'Total Tonnage';
        truckHireCostCard += " (Rate * Number of Tonnes)"

    } else if (vendorBillingType === 'Per KG') {
        vendorUnitsPriceLabel = 'Rate Per Kg';
        vendorTotalUnitsLabel = 'Total Kg'
        truckHireCostCard += " (Rate * Number of Kg)"

    } else if (vendorBillingType === 'Per KM') {
        vendorUnitsPriceLabel = 'Rate Per Km';
        vendorTotalUnitsLabel = 'Total Km'
        truckHireCostCard += " (Rate * Number of Km)"
    }else if (vendorBillingType == "Per Trip") {
      vendorUnitsPriceLabel = 'Rate Per Trip'
      vendorTotalUnitsLabel = 'Total Trips'
      truckHireCostCard += " (Rate * Number of Trips)"
    } else if (vendorBillingType == "Per Day") {
      vendorUnitsPriceLabel = 'Rate Per Day'
      vendorTotalUnitsLabel = 'Total Days'
      truckHireCostCard += " (Rate * Number of Days)"
    } else if (vendorBillingType == "Per Hour") {
      vendorUnitsPriceLabel = 'Rate Per Hour'
      vendorTotalUnitsLabel = 'Total Hours'
      truckHireCostCard += " (Rate * Number of Hours)"
    } else if (vendorBillingType == "Per Litre") {
      vendorUnitsPriceLabel = 'Rate Per Litre'
      vendorTotalUnitsLabel = 'Total Litres'
      truckHireCostCard += " (Rate * Number of Litres)"
    } else if (vendorBillingType == "Per Bag") {
      vendorUnitsPriceLabel = "Rate Per Bag"
      vendorTotalUnitsLabel = "Total Bags"
      truckHireCostCard += " (Rate * Number of Bags)"
    }
    if (vendorBillingType === 'Per Tonne') {
      vendorUnitsPriceLabel = 'Rate Per Tonne';
      vendorTotalUnitsLabel = 'Total Tonnage';
      truckHireCostCard += " (Rate * Number of Tonnes)"

    } else if (vendorBillingType === 'Per KG') {
      vendorUnitsPriceLabel = 'Rate Per Kg';
      vendorTotalUnitsLabel = 'Total Kg'
      truckHireCostCard += " (Rate * Number of Kg)"

    } else if (vendorBillingType === 'Per KM') {
      vendorUnitsPriceLabel = 'Rate Per Km';
      vendorTotalUnitsLabel = 'Total Km'
      truckHireCostCard += " (Rate * Number of Km)"
    } else if (vendorBillingType == "Per Trip") {
      vendorUnitsPriceLabel = 'Rate Per Trip'
      vendorTotalUnitsLabel = 'Total Trips'
      truckHireCostCard += " (Rate * Number of Trips)"
    } else if (vendorBillingType == "Per Day") {
      vendorUnitsPriceLabel = 'Rate Per Day'
      vendorTotalUnitsLabel = 'Total Days'
      truckHireCostCard += " (Rate * Number of Days)"
    } else if (vendorBillingType == "Per Hour") {
      vendorUnitsPriceLabel = 'Rate Per Hour'
      vendorTotalUnitsLabel = 'Total Hours'
      truckHireCostCard += " (Rate * Number of Hours)"
    } else if (vendorBillingType == "Per Litre") {
      vendorUnitsPriceLabel = 'Rate Per Litre'
      vendorTotalUnitsLabel = 'Total Litres'
      truckHireCostCard += " (Rate * Number of Litres)"
    } else if (vendorBillingType == "Per Bag") {
      vendorUnitsPriceLabel = "Rate Per Bag"
      vendorTotalUnitsLabel = "Total Bags"
      truckHireCostCard += "(Rate * Number of Bags)"
    }
    let commonFields = [
        {
            size: 12,
            visible: true,
            inline: false,
            field: (<Radios
              label="Supplier Billing Type"
              name="vendorBillingType"
              required={true}
              formControlProps={{
                margin: 'normal',
                className: classes.billingTypeRadio,
                fullWidth: true
              }}
              onChange={(e) => { setVendorBillingType(e.target.value) }}
              formControlLabelProps={{
                className: classes.supplierBillingTypeLabel
              }}
              formLabelProps={{}}
              radioGroupProps={{ row: true }}
              data={[
                { value: 'Fixed', label: 'Fixed' },
                { value: 'Per Tonne', label: 'Per Tonne' },
                { value: 'Per KG', label: 'Per KG' },
                { value: 'Per KM', label: 'Per KM' },
                { value: 'Per Trip', label: 'Per Trip' },
                { value: 'Per Day', label: 'Per Day' },
                { value: 'Per Hour', label: 'Per Hour' },
                { value: 'Per Litre', label: 'Per Litre' },
                { value: 'Per Bag', label: 'Per Bag' }
              ]}
            />),
        },
        {
          size: 12,
          visible: vendorBillingType !== 'Fixed',
          inline: false,
          field: (
            <TextField
              label={vendorUnitsPriceLabel}
              placeholder={vendorUnitsPriceLabel}
              name="vendorUnitPrice"
              margin="normal"
              onChange={(e) => { setVendorUnitPrice(numberWithCommas(e.target.value)) }}
              fieldProps={{
                parse: value => value && numberWithCommas(value)
              }}
              fullWidth={true}
              variant="outlined"
              size="small"
              required={true}
            />
          ),
        },
        {
          size: 12,
          visible: vendorBillingType !== 'Fixed',
          inline: false,
          field: (
            <TextField
              label={vendorTotalUnitsLabel}
              placeholder={vendorTotalUnitsLabel}
              name="vendorTotalUnits"
              onChange={(e) => { setVendorTotalUnits(e.target.value) }}
              fullWidth={true}
              variant="outlined"
              size="small"
              margin="normal"
              required={true}
            />
          ),
        },
        {
            size: 12,
            visible:vendorBillingType == 'Fixed',
            field: (
              <TextField
                label={'Truck Hire Cost'}
                placeholder="Enter a Amount"
                name="truckHireCost"
                variant="outlined"
                size="small"
                margin="normal"
                onChange={(e)=>setTruckHireCost(numberWithCommas(e.target.value))}
                fieldProps={{
                  parse: value => value && numberWithCommas(value)
                }}
                InputProps={{
                  startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                }}
                required={true}
              />
            ),
        },
        {
          size: 12,
          visible: vendorBillingType !== 'Fixed',
          inline: false,
          field: (
            <Paper className={clsx(classes.unitCard, classes.truckHireCard)}>
              <div><span className={classes.unitDesc}>{truckHireCostCard}</span></div>
              <div><span className={classes.unitAmount}>{numberFormat(Number(values.vendorTotalUnits) * Number(replaceCommas(values.vendorUnitPrice)))}</span></div>
            </Paper>
          ),
        }
    ];
    return commonFields;
  }
  let initialValues = {
    truckHireCost:truckHireCost,
    vendorBillingType: vendorBillingType,
    vendorTotalUnits: vendorTotalUnits,
    vendorUnitPrice: vendorUnitPrice,
  };
  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth='xs'
        onClose={handleClose}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        aria-labelledby={"truck-hire-cost"}
        open={dialogopen}
      >
        <DialogTitle id={"truck-hire-cost"} onClose={handleClose}>
          {editData && editData.id?'Update Truck Hire Cost':'Add Truck Hire Cost'}
        </DialogTitle>
        <TripActionDialogContent dividers>
          <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit; return (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid container alignItems="flex-start" spacing={0}>
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </form>
              )
            }}
          />
        </TripActionDialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button variant="contained" className='modal-save-cta' onClick={event => submit(event)} >
            {editData && editData.id?'Update Truck Hire Cost':'Add Truck Hire Cost'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
const AddEditTruckHireCostWithRouter = withRouter(AddEditTruckHireCost);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchEditVendorExpense: (expenseId, request, onSuccess, onFailure) =>
    dispatch(editVendorExpense(expenseId, request, onSuccess, onFailure)),
    dispatchAddVendorExpense: (request, onSuccess, onFailure) =>
    dispatch(addVendorExpense(request, onSuccess, onFailure)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditTruckHireCostWithRouter);